import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyCumBhZcrePIt5zGXvM30gtKu4gnYawz0w",
    authDomain: "caminhodoparque.firebaseapp.com",
    databaseURL: "https://caminhodoparque.firebaseio.com",
    projectId: "caminhodoparque",
    storageBucket: "caminhodoparque.appspot.com",
    messagingSenderId: "353544278721"
};

firebase.initializeApp(config);

export const database = firebase.database();

export const storage = firebase.storage();


// WEBPACK FOOTER //
// ./src/firebase.js